/**
 * Monta a lista de CNPJs relacionados a partir das informações do usuário.
 * @param {Object} atributosUsuario 
 * @param {Date|null} dataExpiracaoMinima 
 * @returns {Array} Lista de objetos contendo CNPJ, razão social, data inicial, função e data final.
 * Cada objeto tem a seguinte estrutura:
 * {
 *   cnpj: String,
 *   razao_social: String,
 *   data_inicial: String,
 *   papel: String,
 *   data_final: String
 * }
 */
const montaCNPJSRelacionadosGovBr = (atributosUsuario, dataExpiracaoMinima=null) => {
    if (!atributosUsuario) {
        return [];
    }

    // verifica se dataExpiracaoMinima é uma string e converte para Date
    if (dataExpiracaoMinima && !(dataExpiracaoMinima instanceof Date)) {
        dataExpiracaoMinima = new Date(dataExpiracaoMinima);
    } else if (!dataExpiracaoMinima) {
        // se dataExpiracaoMinima for null, pega data atual
        dataExpiracaoMinima = new Date();
    }

    // busca atributos pelo regex govbr_cnpj_{\d{14}}
    const regex = /^govbr_cnpj_(\w{14})$/;
    const cnpjsLinhas = [];
    Object.entries(atributosUsuario).forEach(([key, value]) => {
        const match = key.match(regex);
        // Se não houver correspondência ou o valor for inválido, ignore
        if (!match || !value || !Array.isArray(value) || value.length === 0) {
            return;
        }
        // Se o valor não for uma string ou não contiver '|', ignore
        const valores = value[0].split('|').map(v => v.trim()).filter(v => v);
        if (valores.length === 0) {
            return;
        }
        // Verifica se os campos estão completos
        if (valores.length < 4 || valores.some(valor => !valor)) {
            console.warn(`Dados incompletos para o CNPJ ${match[1]}:`, valores);
            return;
        }

        const dadosCnpj = {
            cnpj: match[1],
            razao_social: valores[0],
            data_inicial: valores[1],
            papel: valores[2],
            data_final: valores[3],
        };

        if (verificaSeDataEstaExpirada(dataExpiracaoMinima, dadosCnpj.data_final)) {
            return;
        }

        cnpjsLinhas.push(dadosCnpj);
    });
    return cnpjsLinhas;
}

/**
 * Verifica se a data final está expirada em relação à data de expiração mínima.
 * @param {Date} dataExpiracaoMinima 
 * @param {Date} dataFinal 
 * @returns 
 */
const verificaSeDataEstaExpirada = (dataExpiracaoMinima, dataFinal) => {
    if (!dataFinal) {
        return false;
    }
    const dataFinalObj = new Date(dataFinal);
    return dataFinalObj < dataExpiracaoMinima;
};

module.exports = montaCNPJSRelacionadosGovBr;
